import ChangeOtpForm from "./components/ChangeOtpForm"

const ChangeOtp = () => {
    return (
        <div>
            <div className="flex justify-center lg:h-full p-6 dark:bg-gray-800">
                <div className="py-6 px-10 lg:flex flex-col flex-1 justify-between bg-white rounded-2xl items-center relative max-w-[520px] 2xl:max-w-[720px]">
                    <div className="login-page-logo mt-8">
                        <img className='mx-auto' src="/portal/img/logo/oasys-logo.png" />
                    </div>
                    <h5 className="mb-1 mt-4 text-center">Change Password</h5>
                    <p className="font-medium heading-text text-center">
                    To make your account secure, please create a new password to replace the temporary password you were given in the email invitation.
                    </p>
                    <ChangeOtpForm/>
                </div>
            </div>
        </div>
    );
}

export default ChangeOtp